<template>
    <div v-show="subscriptionsHaveFetched">
        <div v-if="hasInactiveSubscription && !hasActiveSubscription">
            <restart-account></restart-account>
        </div>
        <div v-else class="main">
            <discount-area
            v-if="showBanner"
            class="discount-banner"
            :coupon="displayBannerData"/>
            <div class="text-center container mx-auto px-2 md:px-16 lg:px-32 xl:px-64 pb-2">
                <div class="px-4 pb-3">
                    <p class="mb-6">
                        {{ $t('DASHBOARD_HI') }} {{ firstName }}
                    </p>
                    <p v-if="hasPendingSubscription" class="mb-2">
                        {{ $t('DASHBOARD_NO_CARD_DETAILS') }}
                    </p>
                    <div v-if="hasPausedSubscription && !hasAnActiveSubscription">
                        <unpause-button :subscription="subscription" :allowRedirect="true"/>
                    </div>
                    <router-link v-if="hasPendingSubscription" class="btn btn--primary text-shadow--none "
                        :to="{name: 'account.manage-account'}"
                        v-html="$t('DASHBOARD_PAYMENT_DETAILS')">
                    </router-link>
                    <p> {{ $t('DASHBOARD_DID_YOU_KNOW') }} </p><br/>
                    <p class="mt-0 pt-0">
                        {{ $t(randomFact) }}
                    </p>
                </div>
            </div>
            <!-- Alert message for customers. To be enabled when required -->
            <!-- <div class="message-banner">
                <p class="message-banner__content text-center" v-text="$t('DASHBOARD_BANNER')"></p>
            </div> -->
            <div class="message-banner text-center" v-if="outstandingOrders.length">
                <p class="message-banner__content" v-text="$t('DASHBOARD_OUTSTANDING_ORDERS')"></p>
                <button type="button" class="btn btn--primary mb-5" @click="go('account.outstanding-orders')">{{$t('DASHBOARD_OUTSTANDING_ORDERS_BUTTON')}}</button>
            </div>
            <div class="divider--container">
                <div class="divider-white--top"></div>
            </div>

            <div class="background--paper">
                <div class="container text-center mx-auto px-2 md:px-16 lg:px-32 xl:px-64 py-6">
                    <div class="flex flex-wrap justify-center">
                        <div v-for="(item, index) in menuItems" :key="index" class="w-1/2 md:w-1/3 mb-2 md:mb-3 lg:mb-6">
                            <icon-box :icon="item" :disabled="hasPendingSubscription && !item.enabledForInactiveUser" :hasGiftingCoupon="hasGiftingCoupon"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="divider-paper--bottom"></div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { DiscountArea } from '@freddiesflowers/frontend-component-library';
import NavigationLinks from '@/config/NavigationLinks';
import IconBox from '@/components/partials/account/dashboard/IconBox';
import RestartAccount from '@/components/forms/account/RestartAccount';
import UnpauseButton from '../../components/partials/account/my-delivery-addresses/UnpauseButton';
import { SUBSCRIPTION_STATUS_PAUSED } from '@/constants/Subscription';

export default {
    name: 'Dashboard',
    components: {
        IconBox,
        RestartAccount,
        DiscountArea,
        UnpauseButton,
    },
    mounted() {
        this.$store.dispatch('account/fetchOutstandingOrders');
        this.$store.dispatch('gifting/fetchGiftingCoupons');
    },
    methods: {
        go(route) {
            this.$router.push({ name: route });
        },
    },
    computed: {
        ...mapGetters({
            firstName: 'account/getFirstName',
            subscriptionsHaveFetched: 'subscription/subscriptionsHaveFetched',
            hasActiveSubscription: 'subscription/getActiveSubscriptionId',
            hasInactiveSubscription: 'subscription/hasInactiveSubscription',
            hasPendingSubscription: 'subscription/hasPendingSubscription',
            subscriptions: 'subscription/getSubscriptions',
            outstandingOrders: 'account/getOutstandingOrders',
            hasAnActiveSubscription: 'subscription/hasActiveSubscription',
            enableShop: 'account/enableShop',
            multiCoupon: 'gifting/getMultiGiftCoupon',
            singleCoupon: 'gifting/getSingleGiftCoupon',
        }),
        displayBannerData() {
            if (this.hasPendingSubscription) {
                const bannerData = this.subscriptions.filter(item => item.referral_coupon !== null);
                return bannerData.length ? bannerData[0].referral_coupon : null;
            }
            return null;
        },
        showBanner() {
            return this.displayBannerData && this.displayBannerData.home_text_1 !== null && this.displayBannerData.home_text_2 !== null;
        },
        subscription() {
            return this.$store.getters['subscription/getSubscriptionById'](this.hasActiveSubscription);
        },
        hasPausedSubscription() {
            return this.subscription.status === SUBSCRIPTION_STATUS_PAUSED;
        },
        menuItems() {
            return NavigationLinks.items
                .filter((item) => typeof item.dashboard !== 'undefined' && item.dashboard.enabled && !(item.route === 'account.shop' && !this.enableShop))
                .map((item) => Object.assign(item.dashboard, item))
                .sort((prevItem, nextItem) => prevItem.order - nextItem.order);
        },
        randomFact() {
            const randomNumber = Math.floor(Math.random() * 15);
            return `DASHBOARD_FACT_${randomNumber}`;
        },
        hasGiftingCoupon() {
            const hasMultiGiftCoupon = this.multiCoupon && typeof this.multiCoupon.code !== 'undefined';
            const hasSingleGiftCoupon = this.singleCoupon && typeof this.singleCoupon.code !== 'undefined';
            return (hasMultiGiftCoupon || hasSingleGiftCoupon);
        },
    },
};
</script>
